import { getLandingPageUrl, getMaintainXUrl } from "../../core/maintainxUrl";
import Button from "../Button/Button";
import ExternalLink from "../ExternalLink/ExternalLink";
import {
  ArrowIcon2,
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  TwitterIcon,
  YoutubeIcon,
} from "../Icons/Icons";
import Logo from "../Logo/Logo";
import styles from "./SiteFooter.module.css";

export default function SiteFooter() {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.logo}>
          <Logo width={204} height={51} />
        </div>
        <p className={styles.copyright}>
          Copyright © {new Date().getFullYear()} MaintainX. All rights reserved.
        </p>
        <ul className={styles.navList}>
          <li className={styles.heading}>Company</li>
          <li className={styles.navItem}>
            <a className={styles.navLink} href={getLandingPageUrl("/about/")}>
              About
            </a>
          </li>
          <li className={styles.navItem}>
            <a className={styles.navLink} href={getLandingPageUrl("/careers/")}>
              Careers
            </a>
          </li>
          <li className={styles.navItem}>
            <a className={styles.navLink} href={getLandingPageUrl("/privacy/")}>
              Privacy Policy
            </a>
          </li>
          <li className={styles.navItem}>
            <a className={styles.navLink} href={getLandingPageUrl("/terms/")}>
              Terms of Service
            </a>
          </li>
        </ul>
        <ul className={styles.navList}>
          <li className={styles.heading}>Product</li>
          <li className={styles.navItem}>
            <a className={styles.navLink} href={getLandingPageUrl("/#features")}>
              Features
            </a>
          </li>
          <li className={styles.navItem}>
            <a className={styles.navLink} href={getLandingPageUrl("/pricing/")}>
              Pricing
            </a>
          </li>
          <li className={styles.navItem}>
            <a className={styles.navLink} href={getLandingPageUrl("/blog/")}>
              Blog
            </a>
          </li>
        </ul>
        <ul className={styles.navList}>
          <li className={styles.heading}>Support</li>
          <li className={styles.navItem}>
            <ExternalLink
              className={styles.navLink}
              href="https://help.getmaintainx.com/about-procedures/"
            >
              FAQ
            </ExternalLink>
          </li>
          <li className={styles.navItem}>
            <ExternalLink className={styles.navLink} href="https://maintainx.dev/">
              API
            </ExternalLink>
          </li>
          <li className={styles.navItem}>
            <a className={styles.navLink} href={getLandingPageUrl("/gdpr/")}>
              GDPR
            </a>
          </li>
        </ul>
        <div>
          <a href={getMaintainXUrl()}>
            <Button iconRight={<ArrowIcon2 />}>Try it free</Button>
          </a>
          <ul className={styles.socialIcons}>
            <li>
              <ExternalLink href="https://www.facebook.com/getMaintainX/">
                <FacebookIcon />
              </ExternalLink>
            </li>
            <li>
              <ExternalLink href="https://www.twitter.com/maintainx/">
                <TwitterIcon />
              </ExternalLink>
            </li>
            <li>
              <ExternalLink href="https://www.youtube.com/channel/UCmAH5odN8n6P1aJITC99ghw/videos/">
                <YoutubeIcon />
              </ExternalLink>
            </li>
            <li>
              <ExternalLink href="https://www.instagram.com/getmaintainx/">
                <InstagramIcon />
              </ExternalLink>
            </li>
            <li>
              <ExternalLink href="https://www.linkedin.com/company/getmaintainx/">
                <LinkedInIcon />
              </ExternalLink>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
